import { client } from "api";
import { Company } from "models/Company";

export type UpdateCompanyRequest = Pick<Company,
  "id" |
  "ueCode" |
  "name" |
  "orgNr" |
  "contactName" |
  "phone" |
  "email" |
  "bookingEmail" |
  "address" |
  "postalCode" |
  "city" |
  "latitude" |
  "longitude" |
  "region" |
  "hourlyRate" |
  "rating" |
  "ratingNotApplicable" |
  "kammarkollegietApproved" |
  "folderUrl" |
  "listedIn5620" |
  "competences"
>

export type UpdateCompanyResponse = string;

export const updateCompany = ({ id, ...request }: UpdateCompanyRequest): Promise<UpdateCompanyResponse> =>
  client.put<UpdateCompanyResponse>(`/company/${id}`, request).then((res) => res.data);
